import React from "react";
import { View } from "react-native";
import { useResponsive } from "../../hooks/useResponsive";
import { useAtom } from "jotai";
import { advertisingAtom, globalFullscreenAtom } from "../../atoms";
import { CenterAdvert } from "../Layout/CenterAdvert";

type AdProviderProps = {
  children: React.ReactNode;
  priority?: number;
  gap?: boolean;
  skip?: boolean;
};

const AdProvider = ({
  children,
  priority,
  gap = true,
  skip = false,
}: AdProviderProps) => {
  if (skip) return <>{children}</>;

  const childrenArray = React.Children.toArray(children);
  const [adverts] = useAtom(advertisingAtom);
  const [isGlobalFullScreen] = useAtom(globalFullscreenAtom);
  if (!adverts?.banner || isGlobalFullScreen)
    return <View>{childrenArray}</View>;

  // allow priority to be set by cms - otherwise should be something 'sensible'
  priority = adverts.banner.banner_priority || priority;

  if (!priority) {
    priority = Math.floor(childrenArray.length / 2);
  }

  if (priority >= 1 && priority <= childrenArray.length) {
    childrenArray.splice(
      priority - 1,
      0,
      <CenterAdvert ad={adverts?.banner} key="center-ad-banner" gap={gap} />
    );
  } else {
    childrenArray.push(
      <CenterAdvert ad={adverts?.banner} key="ad" gap={gap} />
    );
  }

  return <View>{childrenArray}</View>;
};

export default AdProvider;
